import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isRenderableSymbol } from '#pplx/frontend/aether/primitives/IconPrimitive/isRenderableSymbol.js';
import { cx } from 'class-variance-authority';
import { memo } from 'react';
const DEFAULT_STROKE_WIDTH_PX = 1.75;
/**
 * IconSymbolRenderer — self-contained renderer for fetched sprite symbols.
 *
 * The symbol markup ships inside the element (byte-verbatim, in a childless
 * `<g>`) and is `<use>`d in place, so rendering needs no document-level
 * sprite, no defs bookkeeping, and no IconSpriteContext. The wrapper matches
 * IconSprite exactly; the symbol carries its own viewBox and presentation
 * attributes, so per-instance size/strokeWidth/currentColor inherit the same
 * way they do for bundled sprite icons.
 *
 * This is an Aether-internal implementation detail of the icon system.
 * Use `IconPrimitive` with `type="symbol"` instead of importing this
 * directly.
 */
export const IconSymbolRenderer = memo(function IconSymbolRenderer({ icon, size = 20, strokeWidth = DEFAULT_STROKE_WIDTH_PX, title, description, className, style, 'aria-label': ariaLabel, 'aria-hidden': ariaHidden, }) {
    if (icon == null || !isRenderableSymbol(icon)) {
        return null;
    }
    const resolvedSize = size === 'inherit' ? '1em' : size;
    return (_jsxs("svg", { role: "img", className: cx('inline-flex fill-current shrink-0', className), width: resolvedSize, height: resolvedSize, strokeWidth: strokeWidth, style: style, "aria-label": ariaLabel, "aria-hidden": ariaHidden, children: [title && _jsx("title", { children: title }), description && _jsx("desc", { children: description }), _jsx("g", { dangerouslySetInnerHTML: { __html: icon.symbol } }), _jsx("use", { xlinkHref: `#${icon.id}` })] }));
});
//# sourceMappingURL=IconSymbolRenderer.js.map